export default __webpack_public_path__ + "static/media/entrance.7932329f.jpg";